import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import * as RadixProgressBar from '@radix-ui/react-progress';
import { BaseLabel } from '../BaseLabel/BaseLabel.esm.js';
import baseLabelStyles from '../BaseLabel/BaseLabel.styles.esm.js';
import progressBarStyles from './ProgressBar.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const ProgressBar = forwardRef((_a, ref) => {
    var { inverse = false, className, value = 10, size = "md", showLabel = false, percentageText = true, label, "aria-label": ariaLabel } = _a, props = __rest(_a, ["inverse", "className", "value", "size", "showLabel", "percentageText", "label", "aria-label"]);
    const generatedId = useId();
    const { container, innerContainer, base, indicator, percentage, labelTag } = progressBarStyles({
        inverse,
        size,
    });
    const baseLabelClasses = baseLabelStyles({
        inverse,
        variant: "default",
    });
    return (jsxs("div", { className: cn(container(), className), children: [showLabel && (jsx(BaseLabel, { htmlFor: generatedId, inverse: inverse, className: cn(baseLabelClasses, labelTag()), children: label })), jsxs("div", { className: innerContainer(), children: [jsx(RadixProgressBar.Root, Object.assign({ id: generatedId, ref: ref, className: base(), value: value, "aria-live": "polite", "aria-valuetext": `${value}% completed` }, props, (!showLabel ? { "aria-label": ariaLabel } : {}), { children: jsx(RadixProgressBar.Indicator, { className: indicator(), style: {
                                transform: `translateX(-${value > 100 ? 0 : 100 - value}%)`,
                            } }) })), percentageText && (jsxs("div", { className: percentage(), "aria-hidden": true, children: [value, "%"] }))] })] }));
});
ProgressBar.displayName = "ProgressBar";

export { ProgressBar };
